import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const GradientButton = styled(Button, {
  shouldForwardProp: (prop) => !['variant', 'gradient'].includes(prop),
})(({ theme, variant = 'contained', gradient = 'primary' }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '8px',
  fontWeight: 600,
  fontSize: '0.9375rem',
  textTransform: 'none',
  padding: '12px 28px',
  transition: 'all 0.3s ease',

  ...(variant === 'contained' && {
    background: gradient === 'primary'
      ? theme.palette.accent.gradient
      : theme.palette.accent.gradientDark,
    color: '#FFFFFF',
    boxShadow: '0 4px 15px rgba(0, 184, 212, 0.3)',

    '&:hover': {
      background: theme.palette.accent.gradientHover,
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(0, 184, 212, 0.4)',
    },

    '&:active': {
      transform: 'translateY(0)',
    },
  }),

  ...(variant === 'outlined' && {
    background: 'transparent',
    color: gradient === 'light' ? '#FFFFFF' : theme.palette.primary.main,
    border: `2px solid ${gradient === 'light' ? 'rgba(255, 255, 255, 0.5)' : theme.palette.primary.main}`,
    boxShadow: 'none',

    '&:hover': {
      background: gradient === 'light'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 184, 212, 0.08)',
      borderColor: gradient === 'light' ? '#FFFFFF' : theme.palette.primary.light,
      transform: 'translateY(-2px)',
    },

    '&:active': {
      transform: 'translateY(0)',
    },
  }),

  '&.MuiButton-sizeLarge': {
    padding: '14px 36px',
    fontSize: '1rem',
  },

  '&.MuiButton-sizeSmall': {
    padding: '8px 20px',
    fontSize: '0.875rem',
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    transition: 'left 0.5s ease',
  },

  '&:hover::before': {
    left: '100%',
  },
}));

export default GradientButton;
